var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_10607)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 11.3333C13.9998 12.8061 12.8059 14 11.3332 14C9.86042 14 8.6665 12.8061 8.6665 11.3333C8.6665 9.86057 9.86042 8.66667 11.3332 8.66667C12.8059 8.66667 13.9998 9.86057 13.9998 11.3333ZM23.3332 11.3333C23.3332 12.8061 22.1393 14 20.6665 14C19.1937 14 17.9998 12.8061 17.9998 11.3333C17.9998 9.86057 19.1937 8.66667 20.6665 8.66667C22.1393 8.66667 23.3332 9.86057 23.3332 11.3333ZM20.6665 23.3333C22.1393 23.3333 23.3332 22.1394 23.3332 20.6667C23.3332 19.1939 22.1393 18 20.6665 18C19.1937 18 17.9998 19.1939 17.9998 20.6667C17.9998 22.1394 19.1937 23.3333 20.6665 23.3333ZM13.9998 20.6667C13.9998 22.1394 12.8059 23.3333 11.3332 23.3333C9.86042 23.3333 8.6665 22.1394 8.6665 20.6667C8.6665 19.1939 9.86042 18 11.3332 18C12.8059 18 13.9998 19.1939 13.9998 20.6667Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_10607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5610158a.svg";
export { ForwardRef as ReactComponent };